import { useEffect, useRef } from 'react';
import { ConsolidatedLocationView } from '@mark43/cad-api';
import { FieldPath, UseFormReturn, WatchObserver } from 'react-hook-form';
import { RequestAssistanceFormDisplayType } from '../types';
import { get } from 'lodash';

export function useRequestAssistancePrefillOnFormAdd({
    form,
    observerCallback,
}: {
    form: UseFormReturn<RequestAssistanceFormDisplayType>;
    observerCallback: WatchObserver<RequestAssistanceFormDisplayType>;
}): void {
    const lastNumberOfForms = useRef(0);

    useEffect(() => {
        const subscription = form.watch((data, { type }) => {
            // if we have no `type` but `forms` was set, use the form count to determine if a form was removed or added.
            // If a form was added we will trigger prefilling
            if (
                'forms' in data &&
                data.forms &&
                data.forms.length !== lastNumberOfForms.current &&
                !type
            ) {
                const previousNumberOfForms = lastNumberOfForms.current;
                const nextNumberOfForms = data.forms.length;
                // important to adjust this count instantly so that subsequent watch triggers will not hit this branch
                lastNumberOfForms.current = nextNumberOfForms;
                if (nextNumberOfForms > previousNumberOfForms) {
                    const index = nextNumberOfForms - 1;
                    const locationPath: FieldPath<RequestAssistanceFormDisplayType> =
                        `forms.${index}.consolidatedLocationView` as const;
                    const consolidatedLocationViewForIndex: ConsolidatedLocationView | undefined =
                        get(data, locationPath);
                    if (consolidatedLocationViewForIndex) {
                        observerCallback(data, { name: locationPath, type: 'change' });
                    }
                }
            }
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [form, observerCallback]);
}
